import type { EnvironmentConfig } from './environment.types';

export const environment: EnvironmentConfig = {
  appName: 'freightlancer',
  environmentName: 'prod',
  production: true,
  useFakes: false,
  blankState: false,
  transcriptionsUrl: 'wss://transcriptions.freelancer.com',
  authConfig: {
    baseUrl: 'https://www.freelancer.com/auth',
    switchAccountHackyEndpoint:
      'https://www.freelancer.com/ajax-api/navigation/switchaccount.php',
    authHashCookie: 'GETAFREE_AUTH_HASH_V2',
    userIdCookie: 'GETAFREE_USER_ID',
    csrfCookie: 'XSRF-TOKEN',
    gdprCookie: 'requires_gdpr',
    authHeaderName: 'freelancer-auth-v2',
    referralCookie: 'referral_signup',
    authIosKeychainToken: 'freelancer-freight-auth-ios-keychain',
  },
  adminAuthConfig: {
    baseUrl: undefined,
    authHashCookie: undefined,
    userIdCookie: undefined,
    authHeaderName: undefined,
  },
  captchaConfig: {
    recaptchaPublicKey: '6Lc1CCcTAAAAABxlulYmWJj_ZNAHHegrhLV3vS2Z',
    recaptchaV3PublicKey: '6Lfc5-cnAAAAALOb342vomYp_pPkh1Eg_fIv52qX',
  },
  uiConfig: {
    assetsBaseUrl:
      'https://www.f-cdn.com/assets/freightlancer/en-CUSTOM/assets',
    theme: 'freightlancer',
  },
  mapsConfig: {
    apiKey: 'AIzaSyAWB_zZMjdwNlu8-9xZ8RyNRbCERQTWSR8',
  },
  datastoreConfig: {
    webSocketUrl: 'https://notifications.freelancer.com',
    enableStoreFreeze: false,
  },
  freelancerHttpConfig: {
    baseUrl: 'https://www.freelancer.com',
    apiBaseUrl: 'https://www.freelancer.com/api',
    ajaxBaseUrl: 'https://www.freelancer.com/ajax-api',
    authBaseUrl: 'https://www.freelancer.com/auth',
    fileServiceBaseUrl: 'https://www.freelancer.com/fileservice/v4/upload',
  },
  threatmetrixConfig: {
    profilingDomain: 'cdn1.f-cdn.com',
    orgId: 'lar9e74p',
  },
  trackingConfig: {
    trackingEndpoint: 'https://t.freelancer.com/events',
    linkSessionsEndpoint: 'https://t.freelancer.com/link',
    sessionCookie: '_tracking_session',
    linkedSessionCookie: 'uniform_id_linked',
    clientKey: '_tracking_client_session',
    navigationPerformanceSamplingRate: 1,
    enableErrorTracking: true,
    sentryDsn: 'https://29cfb544702b48e0985e69cd3ef5e84f@sentry.io/1410063',
    tracesSampleRate: 0,
    errorSampleRate: 0.2,
    gaTrackingId: 'UA-12895504-1',
    ga4TrackingId: 'G-24PLRZF6VC',
    gAdsTrackingId: 'AW-1059961187',
    gAdsAllowedDomain: undefined,
    awGoogleConversionId: undefined,
    facebookPixelId: 530_993_107_478_103,
    sentryEnvironment: undefined,
    kibanaBaseUrl: undefined,
    gaCustomDimensionMap: {
      dimension1: 'skills',
      dimension2: 'account_type',
      dimension3: 'ab_test_variation',
    },
    linkedInPixelId: '3045346',
    quoraPixelId: '6cfaf7caf340413ebf9b12da0deee3a2',
    hotjarId: 3_380_058,
    tiktokPixelIdMap: {
      australiaNewZealand: undefined,
      canadaAmerica: undefined,
    },
    outbrainPixelId: undefined,
    redditPixelId: undefined,
    bingAdsTagId: '17355653',
  },
  billingConfig: {
    baseUrl: 'https://api.freelancerbilling.com',
  },
  facebookConfig: {
    appId: '120131118061981',
  },
  languageCookies: {
    webappCookie: 'GETAFREE_LANGUAGE',
    nativeCookie: 'GETAFREE_MOBILELANGUAGE',
  },
  seoConfig: {
    linkTags: {
      rss: {
        rel: 'alternative',
        type: 'application/rss+xml',
        title: 'Latest Projects',
        href: '/rss.xml',
      },
    },
    metaTags: {
      robots: {
        name: 'robots',
        content: 'index, follow',
      },
      // /!\ DO NOT add google-site-verification tags here, use file vefication
      // instead.
      alexa: {
        name: 'alexaVerifyID',
        content: 'lOECm39vgYv4N9PwoW6nsSSLiUw',
      },
      bing: {
        name: 'msvalidate.01',
        content: '756854B52F963132E377E441F92F1136',
      },
    },
    defaultMetaImage: 'app-icons/share-thumbnail-1200x630.jpg',
  },
  whitelistCookie: 'IS_WHITELIST_USER',
  siteName: 'Loadshift',
  pwaConfig: {
    appIcon: 'freelancer-logo-icon.svg',
  },
  loginConfig: {
    loggedOutRestricted: false,
    defaultLogoutRedirectUrl: '/',
    ssoIntegration: undefined,
  },
  firebase: {
    apiKey: 'AIzaSyCk13ZnwcFgrMU1Ulr13IyyDlZLqS-UR-Q',
    projectId: 'freelancer-8cd88',
    messagingSenderId: '517773278714',
    appId: '1:517773278714:web:8b59a1922d63d6371af843',
  },
  googleSignInConfig: {
    clientId: undefined,
  },
  messaging: {
    aiChatUserId: 3_779_912,
  },
  lightGallery: {
    licenseKey: 'A6ACF584-D992-4C7C-B6EA-2CB459B194E8',
  },
  applePayConfig: {
    merchantIdentifier: undefined,
  },
  contractsConfig: {
    baseUrl: 'https://contracts.freelancer.com',
  },
  canvasConfig: {
    canvasHost: undefined,
  },
  adyenConfig: {
    account: {
      clientKey: 'live_XKP72HWPXRDJBIYUFVRZOAL2LYA7Y65F',
      platform: 'live',
    },
    account_india: {
      clientKey: 'live_MA3MALELTRH6JJQHERZ5EV6RBUES75R2',
      platform: 'live-in',
    },
  },
};
